import type { MouseEventHandler } from "react";
import { ShareIcon } from "@heroicons/react/outline";
import Button from "components/Button/Button";

interface Props {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

const OfferShareButton = ({ onClick }: Props) => (
  <Button
    icon={<ShareIcon className="text-slate-500 h-4 w-4" />}
    type="rounded"
    onClick={onClick}
    className="!border-slate-500 text-slate-900 clipboard"
  />
);

export default OfferShareButton;
